import { useState, useEffect } from "react";
import { APIGet } from '@tccshared/services/API'

export const getRSSFeed = async (site, args) => {

    try {
        let url = site + '/api/v1/rss/read';
        let qs = [];

        if (args.feed) qs.push('url=' + args.feed);
        if (args.limit) qs.push('limit=' + args.limit);
        let queryString = qs.join('&');

        url += '?' + queryString;

        const res = await APIGet(url)
        const json = await res.json();
        return { status: 'success', data: json };
    } catch (error) {
        return error;
    }

}

export const useRSS = (args, site) => {

    const [loading, setLoading] = useState(true);
    const [result, setResult] = useState(null);

    const load = async () => {
        setLoading(true);
        let res = await getRSSFeed(site, args)

        if (res.status === 'success') {
            setResult(res.data);
            setLoading(false);
        } else {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!site) return;
        load();
    }, [site])

    return {
        loading,
        result
    }

}

